/**
 * Identify if the hostname belongs to a local environment
 */
export default function isLocalDomain(): boolean {
  if (typeof window === "undefined") return false; // SSR safety

  const { hostname } = window.location;
  const assertion = /^(.*\.)?local\..*$/;

  return assertion.test(hostname);
}
